import { useEffect } from "react";
import { Page } from "../../Page";
import { useAuth0 } from "@auth0/auth0-react";
import styles from'./EventTaskWizard.module.css'
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useNavigate } from "react-router-dom";
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setPromptOkCancelOnHome } from "../menu/menuSlice";
import { selectCurrentEventTaskAllocatedUserEmail, setAllocatedUserEmail } from "../currentEventTask/currentEventTaskSlice";
import { selectCurrentPartyEvent } from "../currentPartyEvent/currentPartyEventSlice";
import { loadEventUsersAsync, selectCurrentEventUsers } from "../currentEventUsers/currentEventUsersSlice";
import { setMessage } from "../messageBoxes/messageBoxSlice";
import { BackButton } from "../menu/BackButton";

export function Email() {
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const currentEventUsers = useAppSelector(selectCurrentEventUsers)
    const currentAllocatedUserEmail = useAppSelector(selectCurrentEventTaskAllocatedUserEmail)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(setHomeButtonVisible(true))
        const getUserMetadata = async () => {
            if (isAuthenticated) {  
              try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                  if (currentPartyEvent?.id) {
                      dispatch(loadEventUsersAsync({ 
                                      partyEventId: currentPartyEvent.id,
                                      token: accessToken
                                  }))
                  }
              } catch  {
                  console.log("Error occured getting token or getting event users");
              }
            }
          };
        
          getUserMetadata();
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
        dispatch(setPromptOkCancelOnHome(true))
        dispatch(setMessage('Cancel saving this task and return to the home page?'))
      }, [dispatch, getAccessTokenSilently, isAuthenticated, navigate, currentPartyEvent]);
    return (
        <Page> 
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <br></br>
            <div className={styles.attendeeContainer}>
                        <h2>Select person</h2>

            <span>
                 <div className={styles.eventUserPanel} >
                 <label> Not Selected yet</label> 
                 <div className={styles.radioDot}>
                    <input
                    type='radio' 
                    name='attendee'
                    value=''
                    id='radioInput'
                    onChange={e => dispatch(setAllocatedUserEmail(e.target.value))}>
                    </input>
                     </div>        
                 </div>
            </span>
            {isAuthenticated && currentEventUsers?.map((eventUser) => {
                return (
                    <span>
                        <div className={styles.eventUserPanel}>
                        <label> {eventUser.alias && eventUser.alias?.trim().length>0 ? eventUser.alias:eventUser.email }                 
                        </label>
                        <div className={styles.radioDot}>
                    <input
                    type='radio' 
                    name='attendee'
                    value={eventUser.email}
                    onChange={e => dispatch(setAllocatedUserEmail(e.target.value))}>
                    </input>
                    </div> 
                     </div>
                     </span>
                        
             )
            })}
             </div>
            <br></br>
            <button className={styles.nextButton} onClick={() => {
                navigate('/Notes')
            }}>Next</button>
      
       
       
        </Page>
    )
}